export default () => {
  return {
    promptLevelTemplates: {},

    /**
       * Temporary storage of prompt code -> prompt levels when importing data
       */
    importPromptLevelMaps: [],

    /**
       * Timestamp of last time prompt level templates were fetched
       * We use this to determine if we need to reload the cached prompt level templates
       */
    promptLevelsLastFetchTimestamp: null,
  };
};
